import WineCard from './WineCard';

export default WineCard;
